/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro"

export default graphql`
    query PieceEditQuery($piece_id: ID!) {
        music_viewer {
            piece(id: $piece_id) {
                id
                ...PieceEditBody_piece
            }
        }
    }
`;
